const header = document.querySelector("[data-header]");
const mobileToggle = document.querySelector("[data-mobile-toggle]");
const mobileDrawer = document.querySelector("[data-mobile-drawer]");
const navButtons = document.querySelectorAll(".nav-item .nav-link");

const setHeaderState = () => {
  header.classList.toggle("is-scrolled", window.scrollY > 8);
};

window.addEventListener("scroll", setHeaderState, { passive: true });
setHeaderState();

const heroRail = document.querySelector(".hero");
let heroTimer;

const startHeroAutoplay = () => {
  if (!heroRail || window.matchMedia("(min-width: 721px)").matches) return;
  const slides = Array.from(heroRail.querySelectorAll(".hero-card"));
  if (slides.length < 2) return;
  let index = 0;
  clearInterval(heroTimer);
  heroTimer = setInterval(() => {
    index = (index + 1) % slides.length;
    heroRail.scrollTo({ left: slides[index].offsetLeft, behavior: "smooth" });
  }, 5200);
};

heroRail?.addEventListener("pointerdown", () => clearInterval(heroTimer), { passive: true });
window.addEventListener("resize", startHeroAutoplay);
startHeroAutoplay();

mobileToggle?.addEventListener("click", () => {
  const isOpen = !mobileDrawer.hasAttribute("hidden");
  mobileDrawer.toggleAttribute("hidden", isOpen);
  mobileToggle.setAttribute("aria-label", isOpen ? "Open menu" : "Close menu");
});

mobileDrawer?.addEventListener("click", (event) => {
  if (event.target.matches("a")) {
    mobileDrawer.setAttribute("hidden", "");
    mobileToggle?.setAttribute("aria-label", "Open menu");
  }
});

navButtons.forEach((button) => {
  button.addEventListener("focus", () => button.setAttribute("aria-expanded", "true"));
  button.addEventListener("blur", () => button.setAttribute("aria-expanded", "false"));
});

document.querySelectorAll(".faq-list details").forEach((item) => {
  item.addEventListener("toggle", () => {
    if (!item.open) return;
    document.querySelectorAll(".faq-list details").forEach((other) => {
      if (other !== item) other.removeAttribute("open");
    });
  });
});

document.querySelectorAll(".scroll-shell").forEach((shell) => {
  const rail = shell.querySelector("[data-scroll-rail]");
  const previous = shell.querySelector("[data-scroll-prev]");
  const next = shell.querySelector("[data-scroll-next]");
  if (!rail) return;
  const scrollByCard = (direction) => {
    const card = rail.firstElementChild;
    const distance = card ? card.getBoundingClientRect().width + 18 : rail.clientWidth * 0.8;
    rail.scrollBy({ left: direction * distance, behavior: "smooth" });
  };
  previous?.addEventListener("click", () => scrollByCard(-1));
  next?.addEventListener("click", () => scrollByCard(1));
});

document.querySelectorAll("[data-product-add-form]").forEach((form) => {
  form.addEventListener("submit", async (event) => {
    if (!window.fetch) return;
    event.preventDefault();
    const submitter = event.submitter;
    const button = submitter?.matches("button") ? submitter : form.querySelector(".product-add-button");
    const errorMessage = form.querySelector("[data-product-form-error]");
    button?.setAttribute("aria-busy", "true");
    button?.setAttribute("disabled", "");
    errorMessage?.setAttribute("hidden", "");
    try {
      const formData = submitter ? new FormData(form, submitter) : new FormData(form);
      const redirectTo = submitter?.name === "return_to" ? submitter.value : formData.get("return_to") || form.dataset.cartUrl || "/cart";
      const variantId = Number(formData.get("id"));
      const quantity = Math.max(1, Number(formData.get("quantity") || 1));
      if (!variantId) throw new Error("Missing variant id");
      const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: variantId,
          quantity
        })
      });
      const responseData = await response.json().catch(() => null);
      if (!response.ok) {
        throw new Error(responseData?.description || responseData?.message || "Cart add failed");
      }
      window.location.href = redirectTo;
    } catch (error) {
      if (errorMessage) {
        errorMessage.textContent = error?.message || errorMessage.textContent;
        errorMessage.removeAttribute("hidden");
      }
      button?.removeAttribute("disabled");
      button?.removeAttribute("aria-busy");
    }
  });
});

document.querySelectorAll("[data-quantity-stepper]").forEach((stepper) => {
  const input = stepper.querySelector("input");
  const form = stepper.closest("[data-cart-form]");
  const updateButton = form?.querySelector("[data-cart-update]");
  const autoUpdate = form?.dataset.autoUpdate === "true";
  const updateCart = () => {
    if (autoUpdate && updateButton && form?.requestSubmit) {
      form.requestSubmit(updateButton);
    }
  };
  stepper.querySelector("[data-quantity-minus]")?.addEventListener("click", () => {
    input.value = Math.max(Number(input.min || 0), Number(input.value || 0) - 1);
    updateCart();
  });
  stepper.querySelector("[data-quantity-plus]")?.addEventListener("click", () => {
    input.value = Number(input.value || 0) + 1;
    updateCart();
  });
  input?.addEventListener("change", updateCart);
});

window.lucide?.createIcons();
